import Layout from '@/views/layout/Layout'

const cmsThreadRoutes = {
  path: '/cms/thread',
  component: Layout,
  redirect: '/cms/thread/list',
  name: 'cms.thread',
  meta: { title: '资讯', icon: 'cms' },
  children: [
    {
      path: 'list',
      name: 'cms.thread.list',
      component: () => import('@/views/cms/thread/list'),
      meta: { title: '资讯列表', icon: 'ums-admin' }
    },
    {
      path: 'create',
      name: 'cms.thread.create',
      component: () => import('@/views/cms/thread/create'),
      meta: { title: '创建资讯', icon: 'ums-admin' }
    },
    {
      path: 'edit/:id',
      name: 'cms.thread.edit',
      hidden: true,
      component: () => import('@/views/cms/thread/edit'),
      meta: { title: '编辑资讯', icon: 'ums-admin' }
    },
    {
      path: 'thread-category/list',
      name: 'cms.thread-category.list',
      component: () => import('@/views/cms/thread_category/list'),
      meta: { title: '资讯分类列表', icon: 'ums-admin' }
    }
  ]
}

export default cmsThreadRoutes



// WEBPACK FOOTER //
// ./src/router/module/cmsThreadRoutes.js